module.exports = __webpack_public_path__ + "static/media/team5.66d1853d.jpg";